import { ZfDivider } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { getImageUrlByString } from '../../../../styles/assets/imageMap';
import type { TopicDto } from '../../../api/generated/client';

export interface IProps {
    topic?: TopicDto;
    goBack: () => void;
}

export const TopicScreenPresentationSideBar: FunctionComponent<IProps> = ({ topic, goBack }) => {
    const { t, i18n } = useTranslation();

    return (
        <div
            className="topic-screen__sidebar presentation"
            style={{
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 31.48%, rgba(0, 0, 0, 0.00) 66.57%, rgba(0, 0, 0, 0.40) 100%), url(${getImageUrlByString(
                    topic?.key,
                )})`,
            }}
        >
            <div className="topic-screen__sidebar__header">
                <span onClick={goBack}>{t('cancel')}</span>
                <ZfDivider orientation="vertical" />
                <h4>{topic?.name[i18n.language]}</h4>
            </div>
        </div>
    );
};
